import { ClassNameProps, Column, makeClassName, StyleProps } from "@hex-insights/core";
import { CourseSectionDetailQuery } from "../../../../Utilities";
import { Body } from "./Body";
import { Header } from "./Header";
import styles from "./styles.module.css";

export { type HeaderProps as DetailViewHeaderProps } from "./Header";
export { type BodyProps as DetailViewBodyProps } from "./Body";

export type DetailViewProps = {
	courseSection: CourseSectionDetailQuery["courseSection"];
	courseSectionPeriodTo?: string;
} & Partial<ClassNameProps & StyleProps>;

export function DetailView({ courseSection, courseSectionPeriodTo, className, style }: DetailViewProps) {
	return (
		<Column
			justify="spaced-start"
			verticalSpacing="1rem"
			className={makeClassName(styles["main-column"], className)}
			style={style}
		>
			<DetailView.Header courseSection={courseSection} courseSectionPeriodTo={courseSectionPeriodTo} />
			<DetailView.Body courseSection={courseSection} />
		</Column>
	);
}

DetailView.Header = Header;
DetailView.Body = Body;
